import { render, staticRenderFns } from "./ProducttypeSimple.vue?vue&type=template&id=4e162351&"
import script from "./ProducttypeSimple.vue?vue&type=script&lang=js&"
export * from "./ProducttypeSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports